<!-- Search Form Section Starts -->
<form (ngSubmit)="SearchHotel(searchForm.form.valid)" #searchForm="ngForm" novalidate id="hsearchForm" area="Flights">
  <Section class="search-from">
    <div class="overlay"></div>
    <div class="booking-box">
      <div class="menu-icons-wrapper">
        <div class="menu-icons">
          <div class="icon-tab" routerLink="/flight">
            <img src="assets/images/SRI/Icon/flight-icon.png" alt="Flights"><span>Flights</span>
          </div>
          <div class="icon-tab active" routerLink="/hotel">
            <img src="assets/images/SRI/Icon/hotel-icon.png" alt="Hotel"><span>Hotel</span>
          </div>
          <div class="icon-tab" routerLink="/holiday">
            <img src="assets/images/SRI/Icon/holiday-icon.png" alt="Holidays"
                 style="width: 35%;"><span>Holidays</span>
          </div>
          <div class="icon-tab d-none d-md-flex" routerLink="/transfer">
            <img src="assets/images/SRI/Icon/car-icon.png"
                 alt="transfer"><span>Transfer</span>
          </div>
          <div class="icon-tab d-none d-md-flex" routerLink="/sightseeing">
            <img src="assets/images/SRI/Icon/activity-icon.png" alt="sightseeing"><span>Sightseeing</span>
          </div>
        </div>
      </div>

      <div class="row mb-3 search-frm new-retn-btn">
        <div class="col-4F search-frm-bx">
          <label for="leavingFrom" class="form-label">Destination or Hotel name</label>
          <img class="locationicon" src="./assets/images/SRI/Icon/placeholder.png">
          <input [(ngModel)]="DestinationCity" [typeahead]="hotelResulList"
                 class="form-control padding-left-text-frm ui-autocomplete-input"
                 name="hotelFromCity" (click)="$event.target.select()" #hotelFromCity="ngModel"
                 (typeaheadOnSelect)="formatHotelCity($event)"
                 autocomplete="off" [typeaheadItemTemplate]="hotelSearchTemplate"
                 placeholder="Destination or Hotel name" titles="3 charecters minimum" type="text"
                 [ngClass]="{'is-invalid': searchForm.submitted && hotelFromCity.invalid || !fromCityValid}" required>
          <ng-template #hotelSearchTemplate let-model="item" let-index="index">
            <div class="">
              <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
              {{ model.CityName }} ({{model.CityCode}}), <span>
                {{model.CountryName}}
              </span>
            </div>
          </ng-template>
        </div>

        <div class="col-2 search-frm-bx">
          <label for="departureDate" class="form-label">Check-In</label>
          <div class="input-group sf clander-a" (click)="checkin.show()">
            <input name="checkINDate" placeholder="DD/MM/YYYY" type="text"
                   style="position: absolute; z-index: -1;" value=""
                   class="form-control" id="drpDepartDate" #fromDate="bsDatepicker"
                   bsDatepicker [outsideClick]="true" #checkin="bsDatepicker"
                   [(ngModel)]="HotelSearchModel.Request.Master.CheckIn"
                   [bsConfig]="{ adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD' }"
                   (bsValueChange)="HotelFromDateChange($event);" [minDate]="minDate"
                   [maxDate]="fromMax">
            <span class="form-control calr">
              {{HotelSearchModel.Request.Master.CheckIn | date:'dd-MMM-yyyy'}}
            </span>
          </div>
        </div>
        <div class="col-2 search-frm-bx">
          <label for="returnDate" class="form-label">Check-Out</label>
          <!--Return date-1-->
          <div class="input-group sf clander-a" (click)="checkout.show()">
            <input name="checkOutDate" placeholder="DD/MM/YYYY" type="text"
                   style="position: absolute; z-index: -1;" value=""
                   class="form-control" id="drpDepartDate"
                   bsDatepicker [outsideClick]="true"
                   [(ngModel)]="HotelSearchModel.Request.Master.CheckOut" #checkout="bsDatepicker"
                   [bsConfig]="{ adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD' }"
                   [minDate]="minCheckoutDate">
            <span class="form-control calr">
              {{HotelSearchModel.Request.Master.CheckOut | date:'dd-MMM-yyyy'}}
            </span>
          </div>
        </div>

        <div class="col-3F search-frm-bx dro-trv-main ">
          <label class="form-label">Room & Guests</label>
          <button type='button' class="form-control calr autoheight">
            {{HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length}} Rooms {{GuestCount}} Guest
          </button>
          <div class="drop-trv">
            <div *ngFor="let room of HotelSearchModel.Request.RequestDetails.Search.Rooms.Room;let i=index;">
              <div class="rm-txt">
                Room {{i+1}} :
              </div>
              <div class="left-box">
                <span class="txt">
                  <span id="txt-innr">Adult <em>(Above 12 years)</em></span>
                </span>
              </div>
              <div class="right-box">
                <div class="pls-mns-row">
                  <a type="button" id="adt-min" class="sub" *ngIf="room.Adult>1"
                     (click)="DecreaseGuest('A',i)">-</a>
                  <span id="adlt-nbr" class="adlt-number">
                    {{room.Adult}}
                  </span>
                  <a type="button" id="adt-plus" class="plus" *ngIf="room.Adult<4"
                     (click)="IncreaseGuest('A',i)">+</a>
                </div>
              </div>
              <div class="space-rw">
              </div>
              <div class="left-box">
                <span class="txt">
                  <span id="txt-innr">Child <em>(Below 12 years)</em></span>
                </span>
              </div>
              <div class="right-box">
                <div class="pls-mns-row">
                  <a type="button" id="adt-min" class="sub" *ngIf="room.Child>0"
                     (click)="DecreaseGuest('C',i)">-</a>
                  <span id="adlt-nbr" class="adlt-number">
                    {{room.Child}}
                  </span>
                  <a type="button" id="adt-plus" class="plus" *ngIf="room.Child<4"
                     (click)="IncreaseGuest('C',i)">+</a>
                </div>
              </div>

              <div class="space-rw">
              </div>

            </div>
            <div class="clear"></div>
            <a class="add-room"
               *ngIf="HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length<5"
               (click)="AddRoom()">
              Add Room
            </a>
            <a class="add-room"
               *ngIf="HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length>1"
               (click)="RemoveRoom()">
              Remove Room
            </a>
            <a href="javascript:void(0)" class="done-btn">
              Done
            </a>
          </div>
        </div>
        <div class="col-1F d-flex align-items-end srh-flt padding-0">
          <button type="submit" href="javascript:void(0)" data-hover="SEARCH NOW" (click)="myFormSubmitHandler()" class="btn-slide btnres">&nbsp;Search&nbsp;</button>
        </div>
      </div>

    </div>

  </Section>
</form>
<!-- End Of Search Form -->
